import states from '@zillow/state-names';
import type { SubmitContactParams, SubmitContactResult } from '../types/@zillow-types';

export const DEFAULT_SOURCE = 'OMHDP';
/**
 * Submit contact to Zatlas as a lead
 * @param name from form
 * @param email from form
 * @param phone from form
 * @param property contacted from
 * @param zatlasEndpoint For POST request, should have trailing slash
 */
const submitContact = async ({
    property,
    name,
    email,
    phone,
    zatlasEndpoint,
    source,
}: SubmitContactParams): Promise<SubmitContactResult> => {
    if (!zatlasEndpoint) {
        throw new Error('zatlasEndpoint must be defined');
    }

    const stateName = (states as Record<string, string>)[property.state as string];
    const postData = {
        lead: {
            sender: {
                name,
                phone,
                email,
            },
            property: {
                zpid: property.zpid,
                address: property.streetAddress,
                city: property.city,
                state: stateName,
                zipCode: property.zipcode,
                homeStatus: property.homeStatus,
                market: property.zillowOfferMarket?.name,
            },
            brand: 'Zillow',
            source: source || DEFAULT_SOURCE,
            type: source?.toUpperCase().includes('SEBCMA') ? 'SELLER' : 'OOBB', // OOBB stands for OutOfBuyBox, usage refers to API in zatlas-service
        },
    };

    try {
        const response = await fetch(`${zatlasEndpoint}zatlas-lead-cors`, {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            return {
                errors: {
                    submit: 'Something went wrong. Please try again later',
                },
            };
        }
        return { success: true };
    } catch (error) {
        return {
            errors: {
                submit: 'Something went wrong. Please try again later',
            },
        };
    }
};

export default submitContact;
